import React, { useState, useEffect } from 'react';

const LoadingScreen = () => {
//   const [isLoading, setIsLoading] = useState(true);
  
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setIsLoading(false);
//     }, 1500);
    
//     return () => clearTimeout(timer);
//   }, []);
  
//   if (!isLoading) return null;
  
//   return (
//     <div className="loading-screen">
//       <div className="text-center">
//         <div className="loading-spinner mb-6"></div>
//         <p className="text-primary text-lg font-semibold animate-pulse">Loading Elysian Experience...</p>
//       </div>
//     </div>
//   );
};

export default LoadingScreen;